import React from "react";
import { Styles } from "./styles";
import { Col, Container, Row } from "react-bootstrap";
import MainButton from "../../common/buttons/mainButton/MainButton";
import ReactImg from "../../../assets/images/backGrounds/react.svg";
import AboutImg from "../../../assets/images/home/aboutAr.webp";
import AboutImgEn from "../../../assets/images/home/aboutEn.webp";
import i18next, { t } from "i18next";
import { useSelector } from "react-redux";
import { Fade, Flip } from "react-reveal";
import Spin from "react-reveal/Spin";

const AboutUs = ({ features }) => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);
  const isAr = i18next.language === "ar";

  return (
    <Styles>
      <section id="aboutUsSection">
        <Spin>
          <img src={ReactImg} alt="image" className="react-img" />
        </Spin>
        <Container>
          <Fade bottom>
            <h2 className="section-title">
              {Resource?.about_us_title
                ? Resource?.about_us_title
                : t("home.about_us.title")}
            </h2>
          </Fade>
          <Row>
            <Col lg={6}>
              {isAr ? (
                <Fade right>
                  <div className="about-img">
                    <img src={AboutImg} alt="about-us" />
                  </div>
                </Fade>
              ) : (
                <Fade left>
                  <div className="about-img">
                    <img src={AboutImgEn} alt="about-us" />
                  </div>
                </Fade>
              )}
            </Col>
            <Col lg={6}>
              {isAr ? (
                <Fade left>
                  <div className="about-container">
                    {features?.map((item, idx) => {
                      return (
                        <div key={idx} className="about-item">
                          <div className="item-number">
                            <div className="number">{++idx}</div>
                            <span className="line"></span>
                          </div>
                          <div className="item-data">
                            <div className="item-title">
                              {item?.localizedName}
                            </div>
                            <div className="item-description">
                              {item?.localizedDescription}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Fade>
              ) : (
                <Fade right>
                  <div className="about-container">
                    {features?.map((item, idx) => {
                      return (
                        <div key={idx} className="about-item">
                          <div className="item-number">
                            <div className="number">{++idx}</div>
                            <span className="line"></span>
                          </div>
                          <div className="item-data">
                            <div className="item-title">
                              {item?.localizedName}
                            </div>
                            <div className="item-description">
                              {item?.localizedDescription}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Fade>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
};

export default AboutUs;
